<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="LISTA DE PAGAMENTOS DO DIA" :data="tableData" :dadosRel="dadosRel" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" 
            :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="6" :totalPDF="total" 
            titleReport="Relatório de Pagamentos do dia" :totalHide="true">
                <md-button v-if="permissoes.relatoriosView" class="md-button md-site md-just-icon md-round" :to="{ name: 'relatoriosView' }">
                    <md-icon>assignment</md-icon>
                    <md-tooltip md-direction="top">Relatórios</md-tooltip>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-30 md-xsmall-size-100 md-size-25 ml-auto">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise no resultado aqui." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 10%">{{ item.id }}</md-table-cell>
                        <md-table-cell md-label="TIPO" style="width: 10%">{{ item.tipo }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CLIENTE / CARRO" style="width: 35%">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="CPF / PLACA" style="width: 15%">{{ item.cpf_placa }}</md-table-cell>
                        <md-table-cell v-if="item.data_pagamento == 'TOTAL'" md-label="DATA" style="width: 15%"><strong>{{ item.data_pagamento }}</strong></md-table-cell>
                        <md-table-cell v-else md-label="DATA" style="width: 15%">{{ item.data_pagamento }}</md-table-cell>
                        <md-table-cell v-if="item.data_pagamento == 'TOTAL'" md-label="VALOR" style="width: 10%"><strong>{{ item.valor }}</strong></md-table-cell>
                        <md-table-cell v-else md-label="VALOR" style="width: 10%">{{ item.valor }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-button v-if="item.data_pagamento != 'TOTAL'" @click="pagamento(item.id)" md-menu-trigger class="md-just-icon md-site md-round menuTable">
                                <md-icon>grading</md-icon>
                                 <md-tooltip md-direction="bottom">Comprovantes</md-tooltip>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import Pagamento from '@/config/mixins/print/pagamento'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'PlanoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'pagamentos/',
            rotaExcluir: 'pagamentos/excluir/',
            columnsPDF: [15, 22, 65, 30, 23, 25],
            headRowsPDF: ['ID', 'TIPO', 'CLIENTE / CARRO', 'CPF / PLACA', 'DATA', 'VALOR'],
            bodyRowsPDF: ['id', 'tipo', 'nome', 'cpf_placa', 'data_pagamento', 'valor'],
            fildsTXT: ['id', 'tipo', 'nome', 'cpf_placa', 'data_pagamento', 'valor_bd'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "TIPO",
                    field: "tipo",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CLIENTE / CARRO",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "CPF / PLACA",
                    field: "cpf_placa",
                    dataFormat: this.upperCaseFormat
                },               
                {
                    label: "DATA",
                    field: "data_pagamento"
                }, 
                {
                    label: "VALOR",
                    field: "valor_bd"
                },
            ],
            search: null,
            tableData: [],
            searchedData: [],
            dadosRel: [],
            buscar: {
                busca: '',
                dataInicial: null,
                dataFinal: null
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader, Pagamento],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            let loader = this.openLoader('dots');
            this.$http.post(this.$urlAPI + 'pagamentos/pagamento-fornecedor-dia')
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.dadosRel = response.data.lista
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.cpf_placa, item.data_pagamento, item.valor]).includes(this.toLower(term)))
            }
            return items
        },

        excluir(id, nome) {
            this.handleDelete(id, nome)
        },

        pagamento(id) {
            const dataComprovante = this.searchedData.filter(function (item) {
                return item.id === id
            })
            this.printPagamento(dataComprovante[0])
        }
    },

};
</script>
